import { Theme } from '@mui/material';
import { Colors } from '../../constants';

export const warningModalStyles = (theme?: Theme) => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	root: {
		position: 'relative',
		width: '640px',
		padding: '32px 24px',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		borderRadius: '8px',
		border: `1px solid ${Colors['2A2A2A']}`,
		background: Colors['1E1E1E'],
	},
	closeButton: {
		color: '#FFFFFF',
		position: 'absolute',
		top: '10px',
		right: '10px',
		padding: 0,
	},
	title: {
		color: Colors.white,
		textAlign: 'center',
		fontFamily: 'Montserrat',
		fontSize: '22px',
		fontWeight: 700,
		lineHeight: '140%',
		letterSpacing: '0.22px',
	},
	text: {
		color: Colors.white_a80,
		textAlign: 'center',
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 500,

		'& a': {
			color: Colors.white_a80,
			textDecoration: 'underline',
		}
	},
	submitButton: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '112%',
		gap: '6px',
	},
});
